module.exports = __webpack_public_path__ + "img/logo.f6b6ec14.png";